import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppData } from '@/components/apps/useAppData';
import { OutreachCampaignList } from './OutreachCampaignList';
import { OutreachCampaignView } from './OutreachCampaignView';
import { useOutreach } from './useOutreach';

/**
 * The « sequence » block of an app (03/11/2026), any app whose objects are
 * companies or people. Since 04/11, as in lemlist, it holds campaigns: each a
 * name, its prospects (objects of the app's list, which stays the base), its
 * steps and settings. The list of campaigns, or the one open (?campagne=<id>).
 */
export const OutreachSequenceBlock = ({ appId, canManage, importInHeader = false }: { appId: string; canManage: boolean; importInHeader?: boolean }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const campaignId = searchParams.get('campagne');
  const app = useAppData(appId);
  const data = useOutreach(appId, campaignId);
  const open = useCallback((id: string | null) => {
    setSearchParams((current) => {
      const next = new URLSearchParams(current);
      if (id) next.set('campagne', id); else next.delete('campagne');
      return next;
    });
  }, [setSearchParams]);

  if (app.error || data.error) return <p role="alert" className="text-sm text-domino-inkSoft">{app.error ?? data.error}</p>;
  if (!app.list || !data.state) {
    return (
      <div className="space-y-3" aria-busy="true">
        <div className="h-16 animate-pulse rounded-2xl bg-domino-warm" />
        <div className="h-64 animate-pulse rounded-xl bg-domino-warm" />
      </div>
    );
  }
  if (campaignId && data.campaign) {
    return <OutreachCampaignView appId={appId} app={app} data={data} canManage={canManage} onBack={() => open(null)} onOpen={open} />;
  }
  return <OutreachCampaignList appId={appId} members={app.members} data={data} canImport={canManage && !importInHeader} onOpen={open} />;
};
